import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import styles from './RowAction.module.css';

/**
 * Ação compacta de linha: ícone sem borda com tooltip (o tooltip também explica
 * quando está bloqueada). `label` é o nome para leitor de tela, com o item
 * ("Editar Limpeza de pele"); sem ele, vale o tooltip.
 */
function RowAction({ title, label, onClick, tone = 'neutral', disabled = false, children }) {
    return (
        <Tooltip title={title} arrow>
            <span>
                <button
                    type="button"
                    className={`${styles.button} ${styles[tone] || ''}`}
                    onClick={onClick}
                    disabled={disabled}
                    aria-label={label || title}
                >
                    {children}
                </button>
            </span>
        </Tooltip>
    );
}

export default RowAction;
